import React, { Suspense, useCallback, useEffect, useState } from "react";
import { Routes, Route, Outlet, Navigate } from "react-router-dom";
import { AuthorisedLayout } from "./components/AuthorisedLayout";
import {
  LocalStorage,
  SetSessionItem,
  ClearSessionItems,
  getCurrencyIcon,
} from "./helper/appsession";
import LazyLoad from "./LazyLoad";
import { UserType } from "./helper/fixcode";
import { Loader } from "./components/Shared/PageLoader";
import { axiosPost } from "./apis/useAxios";
import { toast } from "react-toastify";
import { useNotificationHub } from "./hooks/useNotificationHub";
const Wrapper = LazyLoad("@googlemaps/react-wrapper");
/*Dashboard*/
const DashboardComponent = LazyLoad(
  "./components/Dashboard/DashboardComponent",
);
const RMDashboardComponent = LazyLoad(
  "./components/Dashboard/RMDashboardComponent",
);
const DriverManagerDashboardComponent = LazyLoad(
  "./components/Dashboard/DriverManagerDashboardComponent",
);
const FleetDashboard = LazyLoad("./components/Dashboard/FleetDashbaord/index");
const FleetDriverDashboard = LazyLoad(
  "./components/Dashboard/FleetDriverDashboard/index",
);
const FleetVehicleDashboard = LazyLoad(
  "./components/Dashboard/FleetVehicleDashboard/index",
);
const OperationsDashboardComponent = LazyLoad(
  "./components/Dashboard/OperationsDashboard/index",
);
const DmPerformanceDashboardComponent = LazyLoad(
  "./components/Dashboard/DmPerformanceDashboard/index",
);
const CeoDashboardComponent = LazyLoad(
  "./components/Dashboard/CeoDashboard/index",
);
const SchemeMasterPage = LazyLoad("./components/Scheme/SchemeMaster/index");
const SchemeTypeMasterPage = LazyLoad(
  "./components/Scheme/SchemeTypeMaster/index",
);
const ClauseMasterPage = LazyLoad("./components/Scheme/ClauseMaster/index");
const SchemeConfiguratorPage = LazyLoad(
  "./components/Scheme/SchemeConfigurator/index",
);
const SchemeViewPage = LazyLoad("./components/Scheme/SchemeView/index");
const SchemeEditorPage = LazyLoad("./components/Scheme/SchemeEditor/index");
const SchemeExceptionPage = LazyLoad(
  "./components/Scheme/SchemeException/index",
);
const SchemeExceptionFormPage = LazyLoad(
  "./components/Scheme/SchemeException/SchemeExceptionForm",
);
const SchemeExceptionV2Page = LazyLoad(
  "./components/Scheme/SchemeExceptionV2/index",
);
const SchemeExceptionV2FormPage = LazyLoad(
  "./components/Scheme/SchemeExceptionV2/SchemeExceptionV2Form",
);
const PageNotAccessibleComponent = LazyLoad(
  "./components/Shared/PageNotAccessibleComponent",
);
const ComingsoonComponent = LazyLoad("./components/Shared/ComingsoonComponent");
const LoginPage = LazyLoad("./components/LoginPage");
/*Lead*/
const LeadMasterComponent = LazyLoad("./components/Leads/LeadMasterComponent");
const AddLeadsComponents = LazyLoad("./components/Leads/AddLeadsComponents");
const EditLeadsComponents = LazyLoad("./components/Leads/EditLeadsComponents");
const ViewLeadsComponent = LazyLoad("./components/Leads/ViewLeadsComponent");
const RefundComponent = LazyLoad("./components/Refunds/RefundsComponent");
const DashboardLeadsComponent = LazyLoad(
  "./components/Leads/DashboardLeadsComponent",
);
const ImportLeadsComponent = LazyLoad(
  "./components/Leads/ImportLeadsComponent",
);
const LeadRequestLogComponent = LazyLoad(
  "./components/Leads/LeadRequestLogComponent",
);
const AccessPermissionComponent = LazyLoad(
  "./components/Shared/AccessPermissionComponent",
);
/*Driver on boarding*/
const DriverOnboardingComponent = LazyLoad(
  "./components/DriverOnboarding/DriverOnboardingComponent",
);
const ViewDriverOnBoardingComponent = LazyLoad(
  "./components/DriverOnboarding/ViewDriverOnBoardingComponent",
);
const SaveDriverOnboardingComponent = LazyLoad(
  "./components/DriverOnboarding/SaveDriverOnboardingComponent",
);
const DriverOnboardingPipelineListComponent = LazyLoad(
  "./components/DriverOnboarding/DriverOnboardingPipelineListComponent",
);
const LeadsOfficeVisitPipelineListComponent = LazyLoad(
  "./components/DriverOnboarding/LeadsOfficeVisitPipelineListComponent",
);
const LeadsOfficeVisitSummaryListComponent = LazyLoad(
  "./components/DriverOnboarding/LeadsOfficeVisitSummaryListComponent",
);
const LeadSourceOfficeVisitSummaryListComponent = LazyLoad(
  "./components/DriverOnboarding/LeadSourceOfficeVisitSummaryListComponent",
);
const LeadAgreementSummaryListComponent = LazyLoad(
  "./components/DriverOnboarding/LeadAgreementSummaryListComponent",
);
const DriverDocumentQCComponent = LazyLoad(
  "./components/DriverDocumentQC/DriverDocumentQCComponent",
);
const ViewDriverDocumentQCComponent = LazyLoad(
  "./components/DriverDocumentQC/ViewDriverDocumentQCComponent",
);
const LeadAgreementComponent = LazyLoad(
  "./components/Legal/LeadAgreementComponent",
);
const DriverTrainingComponent = LazyLoad(
  "./components/Training/DriverTrainingComponent",
);
const DriverTrainingScheduleComponent = LazyLoad(
  "./components/Training/DriverTrainingScheduleComponent",
);
const DriverPartnerMasterComponent = LazyLoad(
  "./components/DriverPartner/DriverPartnerMasterComponent",
);
const ViewDriverPartnerInfoComponent = LazyLoad(
  "./components/DriverPartnerInfo/ViewDriverPartnerInfoComponent",
);
const ViewDriverPartnerDesignA = LazyLoad(
  "./components/DriverPartnerInfo/ViewDriverPartnerDesignA",
);
const ViewDriverPartnerDesignB = LazyLoad(
  "./components/DriverPartnerInfo/ViewDriverPartnerDesignB",
);
const ViewDriverPartnerDesignC = LazyLoad(
  "./components/DriverPartnerInfo/ViewDriverPartnerDesignC",
);
const ViewDriverPartnerDesignD = LazyLoad(
  "./components/DriverPartnerInfo/ViewDriverPartnerDesignD",
);
const ViewDriverPartnerDesignE = LazyLoad(
  "./components/DriverPartnerInfo/ViewDriverPartnerDesignE",
);
const ViewDriverPartnerInfoNew = LazyLoad(
  "./components/DriverPartnerInfo/ViewDriverPartnerInfoNew",
);
const ViewDriverPartnerBrand = LazyLoad(
  "./components/DriverPartnerInfo/ViewDriverPartnerBrand",
);
const ViewDriverPartnerModern = LazyLoad(
  "./components/DriverPartnerInfo/ViewDriverPartnerModern",
);
const ViewDriverPartnerSplit = LazyLoad(
  "./components/DriverPartnerInfo/ViewDriverPartnerSplit",
);
const ViewDriverPartnerDark = LazyLoad(
  "./components/DriverPartnerInfo/ViewDriverPartnerDark",
);
const DriverPartnerBasicInfoDesign2 = LazyLoad(
  "./components/DriverPartnerInfo/DriverPartnerBasicInfoDesign2",
);
const DriverPartnerBasicInfoDesign3 = LazyLoad(
  "./components/DriverPartnerInfo/DriverPartnerBasicInfoDesign3",
);
const DriverPartnerBasicInfoDesign4 = LazyLoad(
  "./components/DriverPartnerInfo/DriverPartnerBasicInfoDesign4",
);
const DriverPartnerBasicInfoDesign5 = LazyLoad(
  "./components/DriverPartnerInfo/DriverPartnerBasicInfoDesign5",
);
const SaveDriverPartnerDetailsComponent = LazyLoad(
  "./components/EditDriverPartnerDetails/SaveDriverPartnerDetailsComponent",
);
const EditOperatorDocumentComponent = LazyLoad(
  "./components/EditDriverPartnerDetails/EditOperatorDocumentComponent",
);
const DriverLoginHistoryComponent = LazyLoad(
  "./components/DriverPartner/DriverLoginHistoryComponent",
);
/*Vehicle on boarding*/
const CarOnboardingComponent = LazyLoad(
  "./components/CarOnboarding/CarOnboardingComponent",
);
const VehicleQCComponent = LazyLoad(
  "./components/VehicleQC/VehicleQCComponent",
);
const ViewVehicleQCComponent = LazyLoad(
  "./components/VehicleQC/ViewVehicleQCComponent",
);
const VehicleMasterComponent = LazyLoad(
  "./components/Vehicle/VehicleMasterComponent",
);
const VehiclePurchaseComponent = LazyLoad(
  "./components/Vehicle/VehiclePurchaseComponent",
);
const VehicleMasterInfoComponent = LazyLoad(
  "./components/Vehicle/VehicleMasterInfoComponent",
);
const VehicleMasterInfoViewComponent = LazyLoad(
  "./components/Vehicle/VehicleMasterInfoViewComponent",
);
const VehicleComplianceDocumentComponent = LazyLoad(
  "./components/Vehicle/VehicleComplianceDocumentComponent",
);

const VehicleMaintenanceScheduleRenewalComponent = LazyLoad(
  "./components/Vehicle/VehicleMaintenanceScheduleRenewalComponent",
);

const VehicleComplianceDocumentRenewalComponent = LazyLoad(
  "./components/Vehicle/VehicleComplianceDocumentRenewalComponent",
);

const ContactRenewalsComponent = LazyLoad(
  "./components/Vehicle/ContactRenewalsComponent",
);

/*Operation*/
const UberReportDriverStatusComponent = LazyLoad(
  "./components/Payout/UberReportDriverStatusComponent",
);
const UberReportDriverPerformanceComponent = LazyLoad(
  "./components/Payout/UberReportDriverPerformanceComponent",
);

const DriverManagerProxyComponent = LazyLoad(
  "./components/User/DriverManagerProxyComponent",
);
const DriverPartnerAttendanceComponent = LazyLoad(
  "./components/DriverPartner/DriverPartnerAttendanceComponent",
);
const AttendancePhotoCheckListComponent = LazyLoad(
  "./components/DriverPartner/AttendancePhotoCheckListComponent",
);
const VehicleAssignUnassignSummaryListComponent = LazyLoad(
  "./components/DriverPartner/VehicleAssignUnassignSummaryListComponent",
);
const ImportPayoutFuelAdvanceCardDailyComponent = LazyLoad(
  "./components/Payout/ImportPayoutFuelAdvanceCardDailyComponent",
);
/*Scheme*/
const SchemeMasterComponent = LazyLoad(
  "./components/Scheme/SchemeMasterComponent",
);
const SaveSchemeComponents = LazyLoad(
  "./components/Scheme/SaveSchemeComponents",
);
const SchemeAddonComponents = LazyLoad(
  "./components/Scheme/SchemeAddonComponents",
);
const SchemeDeductionComponents = LazyLoad(
  "./components/Scheme/SchemeDeductionComponents",
);
const ImportDriverChangeSchemeComponent = LazyLoad(
  "./components/Scheme/ImportDriverChangeSchemeComponent",
);

/*Payout*/
const PayoutProcessedDataComponent = LazyLoad(
  "./components/Payout/PayoutProcessedDataComponent",
);
const GeneratePayoutComponent = LazyLoad(
  "./components/Payout/GeneratePayoutComponent",
);
const PostPayoutComponent = LazyLoad("./components/Payout/PostPayoutComponent");
const PayoutListComponent = LazyLoad("./components/Payout/PayoutListComponent");
const PayoutViewComponent = LazyLoad("./components/Payout/PayoutViewComponent");
const SystemPayoutAddon = LazyLoad("./components/Payout/SystemPayoutAddon");
const AdjustmentEntry = LazyLoad(
  "./components/Payout/AdjustmentEntry",
);
const SystemPayoutDeduction = LazyLoad(
  "./components/Payout/SystemPayoutDeduction",
);
const SystemPayoutCredit = LazyLoad("./components/Payout/SystemPayoutCredit");
const ImportPayoutDataComponent = LazyLoad(
  "./components/Payout/ImportPayoutDataComponent",
);
const ImportPayoutAdjustmentComponent = LazyLoad(
  "./components/Payout/ImportPayoutAdjustmentComponent",
);
const VehicleRTOComponent = LazyLoad("./components/Payout/VehicleRTOComponent");
const VehicleChallanComponent = LazyLoad(
  "./components/Payout/VehicleChallanComponent",
);
const ChallanListComponent = LazyLoad(
  "./components/Payout/ChallanListComponent",
);
/*Gate Register*/
const GateRegisterComponent = LazyLoad(
  "./components/GateRegister/GateRegisterComponent",
);
/*R & M*/
const VehicleInspectionComponent = LazyLoad(
  "./components/VehicleQC/VehicleInspectionComponent",
);
const VehicleInspectionQCComponent = LazyLoad(
  "./components/VehicleQC/VehicleInspectionQCComponent",
);
const NewInspectionComponent = LazyLoad(
  "./components/VehicleQC/NewInspectionComponent",
);

const VehicleInspectionOneComponent = LazyLoad(
  "./components/VehicleQC/VehicleInspectionOneComponent",
);

const VehicleChangeComponent = LazyLoad(
  "./components/Vehicle/VehicleChangeComponent",
);
const OperatorChangeComponent = LazyLoad(
  "./components/Vehicle/OperatorChangeComponent",
);
const VehicleInfoOnRoadInspectionComponent = LazyLoad(
  "./components/VehicleQC/VehicleInfoOnRoadInspectionComponent",
);
/*Finance*/
const PaymentTransactionComponent = LazyLoad(
  "./components/PaymentTransaction/PaymentTransactionComponent",
);

const RazorpaySettlementReconsComponent = LazyLoad(
  "./components/RazorpaySettlementRecons/RazorpaySettlementReconsComponent",
);
const ImportPayoutCollectionDailyComponent = LazyLoad(
  "./components/Payout/ImportPayoutCollectionDailyComponent",
);
/*Master*/
const CustomerBranchComponent = LazyLoad(
  "./components/Master/CustomerBranchComponent",
);
const CustomerBranchForm = LazyLoad("./components/Master/CustomerBranchForm");
const FeatureComponent = LazyLoad("./components/Feature/FeatureComponent");
const SysStatusComponent = LazyLoad("./components/Master/SysStatusComponent");
const SysCategoryComponent = LazyLoad(
  "./components/Master/SysCategoryComponent",
);
const EmailAlertConfigComponent = LazyLoad(
  "./components/Master/EmailAlertConfig/EmailAlertConfigComponent",
);
const VendorsComponent = LazyLoad("./components/Vendor/VendorsComponent");
const ServiceCenterComponent = LazyLoad(
  "./components/Master/ServiceCenterComponent",
);
const VehiclePartsComponent = LazyLoad(
  "./components/Master/VehiclePartsComponent",
);
const VehicleMakeComponent = LazyLoad(
  "./components/Master/VehicleMakeComponent",
);
const VehicleModelComponent = LazyLoad(
  "./components/Master/VehicleModelComponent",
);
const VehicleVarientComponent = LazyLoad(
  "./components/Master/VehicleVarientComponent",
);
const AccessoryRateCardComponent = LazyLoad(
  "./components/Master/AccessoryRateCardComponent",
);
/*User Management*/
const UserTypeComponent = LazyLoad("./components/User/UserTypeComponent");
const RoleComponent = LazyLoad("./components/Role/RoleComponent");
const UserMasterComponent = LazyLoad("./components/User/UserMasterComponent");
/*Import*/
const ImportDriverDetailsComponent = LazyLoad(
  "./components/DriverDetails/ImportDriverDetailsComponent",
);
const ImportVehicleDetailsComponent = LazyLoad(
  "./components/ImportData/ImportVehicleDetailsComponent",
);
const ImportAssignUnAssignVehicleComponent = LazyLoad(
  "./components/ImportData/ImportAssignUnAssignVehicleComponent",
);
/*Notification*/
const ServiceNotificationBatch = LazyLoad(
  "./components/Notification/ServiceNotificationBatch",
);

/*Job Card*/
const JobCardComponent = LazyLoad("./components/JobCard/JobCardComponent");
const JcEstimateComponent = LazyLoad(
  "./components/JobCard/JcEstimateComponent",
);
const CreateJcEstimateComponent = LazyLoad(
  "./components/JobCard/CreateJcEstimateComponent",
);
const JcEstimateViewPage = LazyLoad("./components/JobCard/JcEstimateViewPage");
const CreateJobCardComponent = LazyLoad(
  "./components/JobCard/CreateJobCardComponent",
);
const CloseJobCardComponent = LazyLoad(
  "./components/JobCard/CloseJobCardComponent",
);

const ApproveJobCardComponent = LazyLoad(
  "./components/JobCard/ApproveJobCardComponent",
);

const ViewJobCardComponent = LazyLoad(
  "./components/JobCard/ViewJobCardComponent",
);
const BankAccountCancelComponent = LazyLoad(
  "./components/Callback/BankAccountCancelComponent",
);
const RazorpayPaymentComponent = LazyLoad(
  "./components/PaymentGateway/RazorpayPaymentComponent",
);
const AgreementVerificationComponent = LazyLoad(
  "./components/Legal/AgreementVerificationComponent",
);

const BankAccountConfirmationComponent = LazyLoad(
  "./components/Callback/BankAccountConfirmationComponent",
);
const DeleteAccountComponent = LazyLoad(
  "./components/Master/DeleteAccountComponent",
);
const AccessoryCategoryComponent = LazyLoad(
  "./components/Master/AccessoryCategoryComponent",
);
const IssueTypeComponent = LazyLoad("./components/Master/IssueTypeComponent");

const TicketComponent = LazyLoad("./components/Ticket/TicketComponent");

/*Change Request*/
const SchemeChangeRequestComponent = LazyLoad(
  "./components/ChangeRequest/SchemeChangeRequestComponent",
);
const SchemeChangeRequestAddComponent = LazyLoad(
  "./components/ChangeRequest/SchemeChangeRequestAddComponent",
);
const SchemeChangeRequestBulkUploadComponent = LazyLoad(
  "./components/ChangeRequest/SchemeChangeRequestBulkUploadComponent",
);
const SchemeChangeRequestApprovalComponent = LazyLoad(
  "./components/ChangeRequest/SchemeChangeRequestApprovalComponent",
);
const SchemeChangeRequestViewComponent = LazyLoad(
  "./components/ChangeRequest/SchemeChangeRequestViewComponent",
);
//Vehicle Branch Change
const OperatorBranchChangeRequestComponent = LazyLoad(
  "./components/ChangeRequest/OperatorBranchChangeRequestComponent",
);
const OperatorBranchChangeRequestAddComponent = LazyLoad(
  "./components/ChangeRequest/OperatorBranchChangeRequestAddComponent",
);

const OperatorBranchChangeRequestViewComponent = LazyLoad(
  "./components/ChangeRequest/OperatorBranchChangeRequestViewComponent",
);
const OperatorBranchChangeRequestApprovalComponent = LazyLoad(
  "./components/ChangeRequest/OperatorBranchChangeRequestApprovalComponent",
);
//Vehicle Branch Change
const VehicleBranchChangeRequestComponent = LazyLoad(
  "./components/ChangeRequest/VehicleBranchChangeRequestComponent",
);

const VehicleBranchChangeRequestAddComponent = LazyLoad(
  "./components/ChangeRequest/VehicleBranchChangeRequestAddComponent",
);

const VehicleBranchChangeRequestViewComponent = LazyLoad(
  "./components/ChangeRequest/VehicleBranchChangeRequestViewComponent",
);

const VehicleBranchChangeRequestApprovalComponent = LazyLoad(
  "./components/ChangeRequest/VehicleBranchChangeRequestApprovalComponent",
);
//Partner Document Change Request
const PartnerDocumentChangeRequestComponent = LazyLoad(
  "./components/ChangeRequest/PartnerDocumentChangeRequestComponent",
);
const PartnerDocumentChangeRequestViewComponent = LazyLoad(
  "./components/ChangeRequest/PartnerDocumentChangeRequestViewComponent",
);
const PartnerDocumentChangeRequestApprovalComponent = LazyLoad(
  "./components/ChangeRequest/PartnerDocumentChangeRequestApprovalComponent",
);
const PartnerDocumentChangeRequestApprovalV2Component = LazyLoad(
  "./components/ChangeRequest/PartnerDocumentChangeRequestApprovalV2Component",
);
const PartnerDocumentChangeRequestApprovalV3Component = LazyLoad(
  "./components/ChangeRequest/PartnerDocumentChangeRequestApprovalV3Component",
);
const PartnerDocumentChangeRequestApprovalV4Component = LazyLoad(
  "./components/ChangeRequest/PartnerDocumentChangeRequestApprovalV4Component",
);
const PartnerDocumentChangeRequestApprovalV5Component = LazyLoad(
  "./components/ChangeRequest/PartnerDocumentChangeRequestApprovalV5Component",
);
const PartnerDocumentChangeRequestApprovalShowcaseComponent = LazyLoad(
  "./components/ChangeRequest/PartnerDocumentChangeRequestApprovalShowcaseComponent",
);
const PartnerDocumentChangeRequestAddComponent = LazyLoad(
  "./components/ChangeRequest/PartnerDocumentChangeRequestAddComponent",
);
const PartnerDocumentChangeRequestAddV2Component = LazyLoad(
  "./components/ChangeRequest/PartnerDocumentChangeRequestAddV2Component",
);
const PartnerDocumentChangeRequestAddShowcaseComponent = LazyLoad(
  "./components/ChangeRequest/PartnerDocumentChangeRequestAddShowcaseComponent",
);
const DriverChangeRequestComponent = LazyLoad(
  "./components/ChangeRequest/DriverChangeRequestComponent",
);
const DriverTerminateComponent = LazyLoad(
  "./components/ChangeRequest/DriverTerminateComponent",
);
const DriverBlackListComponent = LazyLoad(
  "./components/ChangeRequest/DriverBlackListComponent",
);
const DriverParkComponent = LazyLoad(
  "./components/ChangeRequest/DriverParkComponent",
);
const DriverLeftComponent = LazyLoad(
  "./components/ChangeRequest/DriverLeftComponent",
);
const DriverRejoinComponent = LazyLoad(
  "./components/ChangeRequest/DriverRejoinComponent",
);

/*End Route------------------*/

const AddVendorComponent = LazyLoad("./components/Vendor/AddVendorComponent");
const VendorChampionsComponent = LazyLoad(
  "./components/Vendor/VendorChampionsComponent",
);
const SaveDriverPartnerInfoComponent = LazyLoad(
  "./components/DriverOnboarding/SaveDriverPartnerInfoComponent",
);
const SaveAadharCardDetailsComponent = LazyLoad(
  "./components/DriverOnboarding/SaveAadharCardDetailsComponent",
);
const SavePanCardDetailsComponent = LazyLoad(
  "./components/DriverOnboarding/SavePanCardDetailsComponent",
);
const SaveDrivingLicenseDetailsComponent = LazyLoad(
  "./components/DriverOnboarding/SaveDrivingLicenseDetailsComponent",
);
const SaveDriverProfilePhotoComponent = LazyLoad(
  "./components/DriverOnboarding/SaveDriverProfilePhotoComponent",
);
const SavePoliceClearanceCertificateComponent = LazyLoad(
  "./components/DriverOnboarding/SavePoliceClearanceCertificateComponent",
);
const SaveCourtRecordStatusComponent = LazyLoad(
  "./components/DriverOnboarding/SaveCourtRecordStatusComponent",
);
const SaveEmergencyContactComponent = LazyLoad(
  "./components/DriverOnboarding/SaveEmergencyContactComponent",
);
const SaveGuarantorDetailsComponent = LazyLoad(
  "./components/DriverOnboarding/SaveGuarantorDetailsComponent",
);
const SaveAddressDetailsComponent = LazyLoad(
  "./components/DriverOnboarding/SaveAddressDetailsComponent",
);
const SaveBankDetailsComponent = LazyLoad(
  "./components/DriverOnboarding/SaveBankDetailsComponent",
);
const FieldExecutivesComponent = LazyLoad(
  "./components/User/FieldExecutivesComponent",
);
const IncentivesComponent = LazyLoad(
  "./components/Incentives/IncentivesComponent",
);

const IncentiveSchemeComponent = LazyLoad(
  "./components/Incentives/IncentiveSchemeComponent",
);
const TargetMappingComponent = LazyLoad(
  "./components/ChangeRequest/TargetMappingComponent",
);
const MarkCarforRecoveryComponent = LazyLoad(
  "./components/ChangeRequest/MarkCarforRecoveryComponent",
);
const CarImmobilizationComponent = LazyLoad(
  "./components/ChangeRequest/CarImmobilizationComponent",
);

const WaiverComponent = LazyLoad("./components/ChangeRequest/WaiverComponent");
const PenaltyComponent = LazyLoad(
  "./components/ChangeRequest/PenaltyComponent",
);
const VehicleReleaseComponent = LazyLoad(
  "./components/ChangeRequest/VehicleReleaseComponent",
);

const DriverPartnerSettlementComponent = LazyLoad(
  "./components/DriverPartner/DriverPartnerSettlementComponent",
);

const DriverManagerSettlementComponent = LazyLoad(
  "./components/DriverPartner/DriverManagerSettlementComponent",
);

const OperatorMasterComponent = LazyLoad(
  "./components/Operator/OperatorMasterComponent",
);

const OperationsPartnerIncentiveComponent = LazyLoad(
  "./components/Incentives/OperationsPartnerIncentiveComponent",
);

const DriverPartnerParkComponent = LazyLoad(
  "./components/DriverStatusChange/DriverPartnerParkComponent",
);
const DriverPartnerTerminateComponent = LazyLoad(
  "./components/DriverStatusChange/DriverPartnerTerminateComponent",
);

const DriverPartnerBlocklistComponent = LazyLoad(
  "./components/DriverStatusChange/DriverPartnerBlocklistComponent",
);

const WarRoomComponent = LazyLoad("./components/Tracking/WarRoomComponent");

const ViewInventoryVehicleQCComponent = LazyLoad(
  "./components/VehicleQC/ViewInventoryVehicleQCComponent",
);

const CompetitorSchemeComponent = LazyLoad(
  "./components/Scheme/CompetitorSchemeComponent",
);
const Champion = LazyLoad("./components/User/ChampionComponent");

const VehicleAlertsComponent = LazyLoad(
  "./components/Tracking/VehicleAlertsComponent",
);

const RateCardComponent = LazyLoad("./components/Services/RateCardComponent");
const EstimateComponent = LazyLoad("./components/Services/EstimateComponent");
const WorkApprovalComponent = LazyLoad(
  "./components/Services/WorkApprovalComponent",
);

const VehicleProfitLossComponent = LazyLoad(
  "./components/Master/VehicleProfitLossComponent",
);
const StampPaperInventoryComponent = LazyLoad(
  "./components/Legal/StampPaperInventoryComponent",
);
const StampPaperSummaryComponent = LazyLoad(
  "./components/Legal/StampPaperSummaryComponent",
);

const BranchAreaComponent = LazyLoad("./components/Master/BranchAreaComponent");

const VehicleAllocationComponent = LazyLoad(
  "./components/VehicleAllocation/VehicleAllocationComponent",
);
const LeadInfoComponent = LazyLoad("./components/Legal/LeadInfoComponent");

const VehicleInfoComponent = LazyLoad(
  "./components/Legal/VehicleInfoComponent",
);

const SchemeInfoComponent = LazyLoad("./components/Legal/SchemeInfoComponent");

const AgreementContractComponent = LazyLoad(
  "./components/Legal/AgreementContractComponent",
);

const SchemeDepositComponent = LazyLoad(
  "./components/Scheme/SchemeDepositComponent",
);
const SchemeAgreementComponent = LazyLoad(
  "./components/Scheme/SchemeAgreementComponent",
);

const AgentAttendanceLogComponent = LazyLoad(
  "./components/Master/AgentAttendanceLogComponent",
);

const ReportConfigurationComponent = LazyLoad(
  "./components/Configuration/ReportConfigurationComponent",
);
const UberOrgnizationsComponent = LazyLoad(
  "./components/Uber/UberOrgnizationsComponent",
);
const UberSyncDashboardComponent = LazyLoad(
  "./components/Uber/UberSyncDashboardComponent",
);
const UberDataNotificationReportComponent = LazyLoad(
  "./components/Uber/UberDataNotificationReportComponent",
);
const UberDriversComponent = LazyLoad("./components/Uber/UberDriversComponent");
const UberVehiclesComponent = LazyLoad(
  "./components/Uber/UberVehiclesComponent",
);
const UberSupplierPerformanceComponent = LazyLoad(
  "./components/Uber/UberSupplierPerformanceComponent",
);

const GatePassComponent = LazyLoad("./components/Legal/GatePassComponent");
const ItemCategoryComponent = LazyLoad(
  "./components/JobEstimate/ItemCategoryComponent",
);
const ItemsComponent = LazyLoad("./components/JobEstimate/ItemsComponent");
const ItemTypeComponent = LazyLoad(
  "./components/JobEstimate/ItemTypeComponent",
);

const AmeyoToolbarComponent = LazyLoad(
  "./components/Ameyo/AmeyoToolbarComponent",
);
const AdjustmentComponent = LazyLoad(
  "./components/ChangeRequest/AdjustmentComponent",
);

const ParentChildUserMappingComponent = LazyLoad(
  "./components/Master/ParentChildUserMappingComponent",
);

const TeleAgentComponent = LazyLoad("./components/User/TeleAgentComponent");
const PayoutCycleComponent = LazyLoad(
  "./components/Payout/PayoutCycleComponent",
);
const PaymentGatewayComponent = LazyLoad(
  "./components/PaymentGateway/PaymentGatewayComponent",
);

const PayLaterComponent = LazyLoad(
  "./components/PartialPayment/PayLaterComponent",
);
const ReportsComponent = LazyLoad("./components/Report/ReportsComponent");
const LeadSourceCityVisitReportComponent = LazyLoad(
  "./components/Report/LeadSourceCityVisitReportComponent",
);
const AgentBranchReportComponent = LazyLoad(
  "./components/Report/AgentBranchReportComponent",
);

const ChangeOperatorRequestComponent = LazyLoad(
  "./components/ConvertOperator/ChangeOperatorRequestComponent",
);

const AddChangeOperatorRequestComponent = LazyLoad(
  "./components/ConvertOperator/AddChangeOperatorRequestComponent",
);

const AddChangeOperatorRequestV2Component = LazyLoad(
  "./components/ConvertOperator/AddChangeOperatorRequestV2Component",
);

const RequestAddSchemeComponent = LazyLoad(
  "./components/ConvertOperator/RequestAddSchemeComponent",
);

const ApprovalChangeOperatorRequestComponent = LazyLoad(
  "./components/ConvertOperator/ApprovalChangeOperatorRequestComponent",
);

const DepositChangeOperatorRequestComponent = LazyLoad(
  "./components/ConvertOperator/DepositChangeOperatorRequestComponent",
);

const ChangeRequestInfoComponent = LazyLoad(
  "./components/ConvertOperator/ChangeRequestInfoComponent",
);
const ChangeRequestVehicleInfoComponent = LazyLoad(
  "./components/ConvertOperator/ChangeRequestVehicleInfoComponent",
);
const ChangeRequestSchemeInfoComponent = LazyLoad(
  "./components/ConvertOperator/ChangeRequestSchemeInfoComponent",
);
const ViewChangeOperatorRequestComponent = LazyLoad(
  "./components/ConvertOperator/ViewChangeOperatorRequestComponent",
);
const ChangeOperatorPayLaterComponent = LazyLoad(
  "./components/ConvertOperator/ChangeOperatorPayLaterComponent",
);

const UserOtpComponent = LazyLoad("./components/Master/UserOtpComponent");

/*Workflow*/
const WorkflowBuilderComponent = LazyLoad(
  "./components/Workflow/WorkflowBuilderComponent",
);
const WorkflowInstanceComponent = LazyLoad(
  "./components/Workflow/WorkflowInstanceComponent",
);
const MyApprovalsComponent = LazyLoad(
  "./components/Workflow/MyApprovalsComponent",
);

/*My Inbox*/
const MyInboxComponent = LazyLoad("./components/MyInbox/index");

/*Inventory*/
const InventoryComponent = LazyLoad("./components/Inventory/index");
const RequisitionIndex = LazyLoad("./components/Inventory/RequisitionIndex");
const CreateRequisitionComponent = LazyLoad(
  "./components/Inventory/CreateRequisitionComponent",
);
const StockTransferComponent = LazyLoad(
  "./components/Inventory/StockTransferComponent",
);

/*Procurement*/
const ProcurementIndex = LazyLoad("./components/Procurement/index");
const CreateQuotationComponent = LazyLoad(
  "./components/Procurement/CreateQuotationComponent",
);
const QuotationViewPage = LazyLoad(
  "./components/Procurement/QuotationViewPage",
);
const PurchaseOrderIndex = LazyLoad(
  "./components/Procurement/PurchaseOrderIndex",
);
const CreatePoComponent = LazyLoad(
  "./components/Procurement/CreatePoComponent",
);
const PoViewPage = LazyLoad("./components/Procurement/PoViewPage");
const GrnEntryComponent = LazyLoad(
  "./components/Procurement/GrnEntryComponent",
);
const GrnRegister = LazyLoad("./components/Procurement/GrnRegister");
const VendorCompliance = LazyLoad("./components/VendorCompliance/VendorCompliance");
const InventoryReorder = LazyLoad("./components/InventoryReorder/InventoryReorder");
const ProcurementBudget = LazyLoad("./components/ProcurementBudget/ProcurementBudget");
const RateContracts = LazyLoad("./components/RateContracts/RateContracts");
const VendorScorecard = LazyLoad("./components/VendorScorecard/VendorScorecard");
const CompanyContracts = LazyLoad("./components/CompanyContracts/CompanyContracts");
const FittedEquipment = LazyLoad("./components/FittedEquipment/FittedEquipment");
const SpendAnalytics = LazyLoad("./components/SpendAnalytics/SpendAnalytics");
const Disposal = LazyLoad("./components/Disposal/Disposal");
const GstInputCredit = LazyLoad("./components/GstInputCredit/GstInputCredit");
const VehicleLoans = LazyLoad("./components/VehicleLoans/VehicleLoans");
const VendorInvoiceComponent = LazyLoad(
  "./components/Procurement/VendorInvoiceComponent",
);
const VendorQuotationPortal = LazyLoad(
  "./components/Procurement/VendorQuotationPortal",
);
const RfqIndex = LazyLoad("./components/Procurement/RfqIndex");
const CreateRfqComponent = LazyLoad(
  "./components/Procurement/CreateRfqComponent",
);
const RfqComparisonView = LazyLoad(
  "./components/Procurement/RfqComparisonView",
);

/*PMS*/
const PmsTemplateIndex = LazyLoad("./components/Pms/PmsTemplateIndex");
const CreatePmsTemplateComponent = LazyLoad(
  "./components/Pms/CreatePmsTemplateComponent",
);
const VehiclePmsDashboard = LazyLoad("./components/Pms/VehiclePmsDashboard");
const PmsFleetDashboard = LazyLoad("./components/Pms/PmsFleetDashboard");

/*Fleet Expenses*/
const FleetExpensesComponent = LazyLoad("./components/FleetExpenses/index");
const ExpenseLimitSettingsComponent = LazyLoad(
  "./components/Master/ExpenseLimitSettingsComponent",
);
const VehicleExpenseConfigComponent = LazyLoad(
  "./components/Master/VehicleExpenseConfigComponent",
);
const ExpenseReservePoolComponent = LazyLoad(
  "./components/FleetExpenses/ExpenseReservePoolComponent",
);
const FleetItemMasterComponent = LazyLoad(
  "./components/Master/FleetItemMasterComponent",
);
const CostBenchmarkAdminComponent = LazyLoad(
  "./components/CostBenchmark/CostBenchmarkAdminComponent",
);
const PayoutEngine = LazyLoad("./components/PayoutEngine");
const PayoutEngineDriverPage = LazyLoad("./components/PayoutEngine/DriverPage");
const PayoutEngineGenerate = LazyLoad("./components/PayoutEngine/GeneratePage");
const VehicleCost = LazyLoad("./components/VehicleCost/VehicleCost");
const VehicleRmCost = LazyLoad("./components/VehicleRmCost/VehicleRmCost");
const TyresBatteries = LazyLoad("./components/TyresBatteries/TyresBatteries");
const VehiclePLDashboard = LazyLoad(
  "./components/VehiclePL/VehiclePLDashboard",
);
// Reports › Uber (live Uber Supplier API) and Master › Uber API Settings
const UberLiveBoard = LazyLoad("./components/UberReports/UberLiveBoard");
const UberDriverRoster = LazyLoad("./components/UberReports/UberDriverRoster");
const UberVehicleRoster = LazyLoad("./components/UberReports/UberVehicleRoster");
const UberEarnings = LazyLoad("./components/UberReports/UberEarnings");
const UberTransactions = LazyLoad("./components/UberReports/UberTransactions");
const UberMyFleet = LazyLoad("./components/UberReports/UberMyFleet");
const UberQualification = LazyLoad("./components/UberReports/UberQualification");
const UberDmScorecard = LazyLoad("./components/UberReports/UberDmScorecard");
const FleetTrends = LazyLoad("./components/UberReports/FleetTrends");
const FleetHierarchyComponent = LazyLoad("./components/Master/FleetHierarchyComponent");
const CampaignMaster = LazyLoad("./components/Master/Campaign");
const UberScorecard = LazyLoad("./components/UberReports/UberScorecard");
const UberApiSettings = LazyLoad("./components/Master/UberApiSettingsComponent");

// PLEXI-007 — consume UTWiz Portal SSO token from URL hash (#access_token=...)
async function consumeAuthFromHash() {
  const hash = window.location.hash.substring(1);
  if (!hash) return false;
  const params = new URLSearchParams(hash);
  const accessToken = params.get("access_token");
  if (!accessToken) return false;
  window.history.replaceState(
    null,
    "",
    window.location.pathname + window.location.search,
  );
  try {
    const response = await axiosPost("authorize/sso", { token: accessToken });
    if (response?.success && response?.payload) {
      const u = response.payload;
      ClearSessionItems();
      SetSessionItem("authorized", true);
      SetSessionItem("authtoken", crypto.randomUUID());
      SetSessionItem("userid", u.userId);
      SetSessionItem("username", u.userName);
      SetSessionItem("firstname", u.firstName);
      SetSessionItem("lastname", u.lastName);
      SetSessionItem("usertypeid", u.userTypeId);
      SetSessionItem("usertypename", u.userTypeName);
      SetSessionItem("mobile", u.mobileNo);
      SetSessionItem("email", u.email);
      SetSessionItem("profilephotourl", u.profilePhotoUrl);
      SetSessionItem("customerid", u.customerId);
      SetSessionItem("branchid", u.branchId);
      SetSessionItem("branchname", u.brancName);
      SetSessionItem("currencyicon", getCurrencyIcon(u.currencyCode));
      SetSessionItem("ameyousername", u.ameyoUserName);
      SetSessionItem("ameyopasscode", u.ameyoPasscode);
      SetSessionItem("ameyoaccess", u.ameyoAccess);
      SetSessionItem("trackingguid", u.trackingGuid);
      SetSessionItem("sso_login", "true"); // PLEXI-007: flag for logout redirect

      // Write feature data directly to sessionStorage — bypasses ToString() trim chain
      // and ensures both keys SideBarComponent reads are populated.
      const featureJson = JSON.stringify(u.featureAccess ?? []);
      sessionStorage.setItem("session_userFeatureSetup", featureJson);
      sessionStorage.setItem("session_features", featureJson);

      // Navigate to first permitted page using an absolute path so it always
      // resolves to the root regardless of the current pathname.
      const features = u.featureAccess ?? [];
      let locationPath = features[0]?.requestPath ?? "";
      if (!locationPath) {
        const child = features.find((f) => f.parentFeatureId > 0);
        locationPath = child ? child.requestPath : "permission";
      }
      window.location.href = "/" + locationPath.replace(/^\//, "");
      return true;
    }
  } catch (err) {
    // SSO failed — fall through to login screen
  }
  return false;
}

function App() {
  // PLEXI-007: detect SSO token synchronously so we never paint the login screen.
  // Initialised once — true only when there is an #access_token hash and no active session.
  const [ssoInProgress, setSsoInProgress] = useState(
    () =>
      !LocalStorage.IsAuthorized &&
      window.location.hash.includes("access_token="),
  );
  console.log("API URL:", process.env.REACT_APP_API_URL);
  useEffect(() => {
    if (!ssoInProgress) return;
    consumeAuthFromHash()
      .then((ok) => {
        if (!ok) setSsoInProgress(false);
      })
      .catch(() => setSsoInProgress(false));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleNotification = useCallback((payload) => {
    toast.info(payload?.title || "New notification", {
      position: "top-right",
      autoClose: 5000,
      onClick: () => {
        window.location.href = "/my-inbox";
      },
    });
    // Tell TopBarComponent to refresh badge immediately
    window.dispatchEvent(new CustomEvent("wti:notification"));
  }, []);

  useNotificationHub({
    onNotification: LocalStorage.IsAuthorized ? handleNotification : null,
  });
  // const { isNetworkError, setIsNetworkError } = useNetwork();
  // if (isNetworkError) {
  //   return (
  //     <PageNotAccessibleComponent onRetry={() => setIsNetworkError(false)} />
  //   );
  // }
  const isAuthorized = LocalStorage.IsAuthorized;

  // PLEXI-007: show a blank loading screen while the SSO token is being validated —
  // prevents the login form from flashing before the redirect fires.
  if (ssoInProgress) {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
          flexDirection: "column",
          gap: 12,
        }}
      >
        <div className="spinner-border text-primary" role="status" />
        <span style={{ color: "#666", fontSize: 14 }}>
          Signing in via UTWiz Platform…
        </span>
      </div>
    );
  }

  return (
    <>
      {isAuthorized === true ? (
        <AuthorisedLayout>
          <Routes>
            <Route path="/" element={<AuthorizedRouteWrapper />}>
              <Route path="*" element={<RanderDashboard />} />
              <Route path="/" element={<RanderDashboard />} />
              <Route path="/home" element={<RanderDashboard />} />
              <Route path="/dashboard-lead" element={<DashboardComponent />} />
              <Route path="/dashboard-rm" element={<RMDashboardComponent />} />
              <Route
                path="/dashboard-dm"
                element={<DriverManagerDashboardComponent />}
              />
              <Route path="/dashboard-fleet" element={<FleetDashboard />} />
              <Route
                path="/dashboard-fleet-driver"
                element={<FleetDriverDashboard />}
              />
              <Route
                path="/dashboard-fleet-vehicle"
                element={<FleetVehicleDashboard />}
              />
              <Route
                path="/dashboard-operations"
                element={<OperationsDashboardComponent />}
              />
              <Route
                path="/dashboard-dm-performance"
                element={<DmPerformanceDashboardComponent />}
              />
              <Route
                path="/dashboard-ceo"
                element={<CeoDashboardComponent />}
              />
              <Route path="/schemes" element={<SchemeMasterPage />} />
              <Route path="/schemes/new" element={<SchemeConfiguratorPage />} />
              <Route
                path="/schemes/:id/edit"
                element={<SchemeConfiguratorPage />}
              />
              <Route path="/schemes/:id/view" element={<SchemeViewPage />} />
              <Route path="/schemes/new-v3" element={<SchemeEditorPage />} />
              <Route path="/schemes/:id/edit-v3" element={<SchemeEditorPage />} />
              <Route
                path="/schemes/:id/view-classic"
                element={<SchemeConfiguratorPage readOnly={true} />}
              />
              <Route
                path="/schemes/:id/exceptions"
                element={<SchemeExceptionPage />}
              />
              <Route
                path="/schemes/:id/exceptions/new"
                element={<SchemeExceptionFormPage />}
              />
              <Route
                path="/schemes/:id/exceptions/:exId/edit"
                element={<SchemeExceptionFormPage />}
              />
              <Route
                path="/schemes/:id/exceptions-v2"
                element={<SchemeExceptionV2Page />}
              />
              <Route
                path="/schemes/:id/exceptions-v2/new"
                element={<SchemeExceptionV2FormPage />}
              />
              <Route
                path="/schemes/:id/exceptions-v2/:exId/edit"
                element={<SchemeExceptionV2FormPage />}
              />
              <Route
                path="/exceptions-v2/new"
                element={<SchemeExceptionV2FormPage />}
              />
              <Route path="/welcome" element={<ComingsoonComponent />} />
              <Route exact path="/leads" element={<LeadMasterComponent />} />
              <Route exact path="/leads-add" element={<AddLeadsComponents />} />
              <Route
                exact
                path="/leads-edit"
                element={<EditLeadsComponents />}
              />
              <Route
                exact
                path="/leads-view"
                element={<ViewLeadsComponent />}
              />
              <Route
                exact
                path="/leads-import"
                element={<ImportLeadsComponent />}
              />
              <Route
                exact
                path="/leads-request-logs"
                element={<LeadRequestLogComponent />}
              />
              <Route path="/refund" element={<RefundComponent />} />
              <Route
                exact
                path="/dashboard-leads"
                element={<DashboardLeadsComponent />}
              />
              {/*Driver on boarding */}
              <Route
                exact
                path="/driver-boarding"
                element={<DriverOnboardingComponent />}
              />
              <Route
                exact
                path="/driver-boarding-view"
                element={<ViewDriverOnBoardingComponent />}
              />
              <Route
                exact
                path="/driver-boarding-save"
                element={<SaveDriverOnboardingComponent />}
              />
              <Route
                exact
                path="/driver-boarding-pipeline-list"
                element={<DriverOnboardingPipelineListComponent />}
              />
              <Route
                exact
                path="/leads-office-visit-pipeline-list"
                element={<LeadsOfficeVisitPipelineListComponent />}
              />
              <Route
                exact
                path="/leads-office-visit-summary-list"
                element={<LeadsOfficeVisitSummaryListComponent />}
              />
              <Route
                exact
                path="/leads-office-visit-summary-by-source"
                element={<LeadSourceOfficeVisitSummaryListComponent />}
              />
              <Route
                exact
                path="/leads-agreement-summary-list"
                element={<LeadAgreementSummaryListComponent />}
              />
              <Route
                exact
                path="/driver-training"
                element={<DriverTrainingComponent />}
              />
              <Route
                exact
                path="/driver-training-schedule"
                element={<DriverTrainingScheduleComponent />}
              />
              <Route
                path="/document-qc"
                element={<DriverDocumentQCComponent />}
              />
              <Route
                path="/view-document-qc"
                element={<ViewDriverDocumentQCComponent />}
              />
              <Route
                path="/driver-agreement"
                element={<LeadAgreementComponent />}
              />
              <Route
                exact
                path="/driver-partner-master"
                element={<DriverPartnerMasterComponent />}
              />

              <Route
                exact
                path="/driver-partner-master-view"
                element={<ViewDriverPartnerInfoComponent />}
              />
              <Route
                exact
                path="/driver-partner-view-design-a"
                element={<ViewDriverPartnerDesignA />}
              />
              <Route
                exact
                path="/driver-partner-view-design-b"
                element={<ViewDriverPartnerDesignB />}
              />
              <Route
                exact
                path="/driver-partner-view-design-c"
                element={<ViewDriverPartnerDesignC />}
              />
              <Route
                exact
                path="/driver-partner-view-design-d"
                element={<ViewDriverPartnerDesignD />}
              />
              <Route
                exact
                path="/driver-partner-view-design-e"
                element={<ViewDriverPartnerDesignE />}
              />
              <Route
                exact
                path="/driver-partner-master-view-new"
                element={<ViewDriverPartnerInfoNew />}
              />
              <Route
                exact
                path="/driver-partner-master-view-brand"
                element={<ViewDriverPartnerBrand />}
              />
              <Route
                exact
                path="/driver-partner-master-view-modern"
                element={<ViewDriverPartnerModern />}
              />
              <Route
                exact
                path="/driver-partner-master-view-split"
                element={<ViewDriverPartnerSplit />}
              />
              <Route
                exact
                path="/driver-partner-master-view-dark"
                element={<ViewDriverPartnerDark />}
              />
              <Route
                exact
                path="/driver-partner-overview-design-2"
                element={<DriverPartnerBasicInfoDesign2 />}
              />
              <Route
                exact
                path="/driver-partner-overview-design-3"
                element={<DriverPartnerBasicInfoDesign3 />}
              />
              <Route
                exact
                path="/driver-partner-overview-design-4"
                element={<DriverPartnerBasicInfoDesign4 />}
              />
              <Route
                exact
                path="/driver-partner-overview-design-5"
                element={<DriverPartnerBasicInfoDesign5 />}
              />
              <Route
                exact
                path="/driver-partner-master-edit"
                element={<SaveDriverPartnerDetailsComponent />}
              />
              <Route
                exact
                path="/driver-document-edit"
                element={<EditOperatorDocumentComponent />}
              />
              <Route
                exact
                path="/driver-login-history"
                element={<DriverLoginHistoryComponent />}
              />
              {/*Vehicle on boarding*/}
              <Route
                path="/car-boarding"
                element={<CarOnboardingComponent />}
              />
              <Route
                exact
                path="/vehicle-boarding-qc"
                element={<VehicleQCComponent />}
              />
              <Route
                exact
                path="/vehicle-boarding-qc-view"
                element={<ViewVehicleQCComponent />}
              />
              <Route
                exact
                path="/vehicle-purchase"
                element={<VehiclePurchaseComponent />}
              />
              <Route
                exact
                path="/vehicle-master"
                element={<VehicleMasterComponent />}
              />
              <Route
                exact
                path="/vehicle-master-info"
                element={<VehicleMasterInfoComponent />}
              />
              <Route
                exact
                path="/vehicle-master-info-view"
                element={<VehicleMasterInfoViewComponent />}
              />
              <Route
                exact
                path="/vehicle-compliance-document"
                element={<VehicleComplianceDocumentComponent />}
              />
              <Route
                exact
                path="/vehicle-compliance-renewal"
                element={<VehicleComplianceDocumentComponent />}
              />

              <Route
                exact
                path="/service-reminders"
                element={<VehicleMaintenanceScheduleRenewalComponent />}
              />
              <Route
                exact
                path="/vehicle-renewals"
                element={<VehicleComplianceDocumentRenewalComponent />}
              />
              <Route
                exact
                path="/contact-renewals"
                element={<ContactRenewalsComponent />}
              />
              {/*Operation*/}
              <Route
                exact
                path="/uber-driver-status"
                element={<UberReportDriverStatusComponent />}
              />
              <Route
                exact
                path="/uber-driver-performance"
                element={<UberReportDriverPerformanceComponent />}
              />
              <Route
                exact
                path="/driver-manager"
                element={<DriverManagerProxyComponent />}
              />
              <Route
                exact
                path="/driver-attendance"
                element={<DriverPartnerAttendanceComponent />}
              />
              <Route
                exact
                path="/attendance-photo-check"
                element={<AttendancePhotoCheckListComponent />}
              />
              <Route
                exact
                path="/vehicle-assign-unassign-summary-list"
                element={<VehicleAssignUnassignSummaryListComponent />}
              />
              <Route
                exact
                path="/import-payout-fuel-advance-card-daily"
                element={<ImportPayoutFuelAdvanceCardDailyComponent />}
              />
              {/*Scheme — old sidebar link redirects to new page*/}
              {/* <Route path="/scheme-master" element={<Navigate to="/schemes" replace />} /> */}
              <Route
                exact
                path="/scheme-master"
                element={<SchemeMasterComponent />}
              />
              <Route
                exact
                path="/scheme-type-list"
                element={<SchemeTypeMasterPage />}
              />
              <Route
                exact
                path="/clause-master"
                element={<ClauseMasterPage />}
              />
              <Route
                exact
                path="/scheme-save"
                element={<SaveSchemeComponents />}
              />
              <Route
                exact
                path="/scheme-addon"
                element={<SchemeAddonComponents />}
              />
              <Route
                exact
                path="/scheme-deduction"
                element={<SchemeDeductionComponents />}
              />
              <Route
                path="/import-driver-change-scheme"
                element={<ImportDriverChangeSchemeComponent />}
              />
              {/*Payout*/}
              <Route
                exact
                path="/payout-data"
                element={<PayoutProcessedDataComponent />}
              />
              <Route
                exact
                path="/payout-generate"
                element={<GeneratePayoutComponent />}
              />
              <Route
                exact
                path="/payout-post"
                element={<PostPayoutComponent />}
              />
              <Route exact path="/payout" element={<PayoutListComponent />} />
              <Route path="/payout-cycle" element={<PayoutCycleComponent />} />
              <Route
                exact
                path="/payout-view"
                element={<PayoutViewComponent />}
              />
              <Route
                exact
                path="/payout-sys-addon"
                element={<SystemPayoutAddon />}
              />
              <Route
                exact
                path="/payout-adjustment-entry"
                element={<AdjustmentEntry />}
              />
              <Route
                exact
                path="/payout-sys-deduction"
                element={<SystemPayoutDeduction />}
              />
              <Route
                exact
                path="/payout-sys-credit"
                element={<SystemPayoutCredit />}
              />
              <Route
                exact
                path="/import-payout-data"
                element={<ImportPayoutDataComponent />}
              />
              <Route
                exact
                path="/import-payout-adjustment"
                element={<ImportPayoutAdjustmentComponent />}
              />
              <Route
                exact
                path="/vehicle-rto"
                element={<VehicleRTOComponent />}
              />
              <Route
                exact
                path="/vehicle-challan"
                element={<VehicleChallanComponent />}
              />
              <Route
                exact
                path="/challan-list"
                element={<ChallanListComponent />}
              />
              {/*Gate Register*/}
              <Route
                exact
                path="/gate-register"
                element={<GateRegisterComponent />}
              />
              {/*R & M*/}
              <Route
                exact
                path="/vehicle-inspection"
                element={<VehicleInspectionComponent />}
              />
              <Route
                exact
                path="/vehicle-inspection-qc"
                element={<VehicleInspectionQCComponent />}
              />
              <Route
                exact
                path="/new-inspection"
                element={<NewInspectionComponent />}
              />
              <Route
                exact
                path="/new-vehicle-inspection"
                element={<VehicleInspectionOneComponent />}
              />
              <Route
                exact
                path="/vehicle-assign"
                element={<VehicleChangeComponent />}
              />
              <Route
                exact
                path="/operator-assign"
                element={<OperatorChangeComponent />}
              />
              <Route
                exact
                path="/vehicle-onroad-inspection"
                element={<VehicleInfoOnRoadInspectionComponent />}
              />
              {/*Finance*/}
              <Route
                path="/payment-transaction"
                element={<PaymentTransactionComponent />}
              />
              <Route
                path="/settlement-recons"
                element={<RazorpaySettlementReconsComponent />}
              />
              <Route
                exact
                path="/import-payout-collection-daily"
                element={<ImportPayoutCollectionDailyComponent />}
              />
              {/* Master*/}
              <Route
                exact
                path="/customer-branch"
                element={<CustomerBranchComponent />}
              />
              <Route
                exact
                path="/customer-branch-form"
                element={<CustomerBranchForm />}
              />
              <Route path="/feature" element={<FeatureComponent />} />
              <Route path="/status" element={<SysStatusComponent />} />
              <Route path="/category" element={<SysCategoryComponent />} />
              <Route path="/campaign" element={<CampaignMaster />} />
              <Route
                path="/email-alert-configuration"
                element={<EmailAlertConfigComponent />}
              />
              <Route exact path="/vendors" element={<VendorsComponent />} />
              <Route
                path="/service-center"
                element={<ServiceCenterComponent />}
              />
              <Route
                exact
                path="/vehicle-parts"
                element={<VehiclePartsComponent />}
              />
              <Route
                exact
                path="/vehicle-make"
                element={<VehicleMakeComponent />}
              />
              <Route
                exact
                path="/vehicle-model"
                element={<VehicleModelComponent />}
              />
              <Route
                exact
                path="/vehicle-varient"
                element={<VehicleVarientComponent />}
              />
              <Route
                exact
                path="/accessory-rate-card"
                element={<AccessoryRateCardComponent />}
              />
              {/* User Management*/}
              <Route exact path="/user-type" element={<UserTypeComponent />} />
              <Route exact path="/role" element={<RoleComponent />} />
              <Route exact path="/users" element={<UserMasterComponent />} />
              {/*Import*/}
              <Route
                exact
                path="/import-drivers"
                element={<ImportDriverDetailsComponent />}
              />
              <Route
                exact
                path="/import-vehicles"
                element={<ImportVehicleDetailsComponent />}
              />
              <Route
                exact
                path="/import-assign-unassign-vehicles"
                element={<ImportAssignUnAssignVehicleComponent />}
              />
              {/*Notification*/}
              <Route
                exact
                path="/service-notification"
                element={<ServiceNotificationBatch />}
              />
              {/*Job card*/}
              <Route exact path="/job-card" element={<JobCardComponent />} />
              <Route
                exact
                path="/jc-estimate"
                element={<JcEstimateComponent />}
              />
              <Route
                exact
                path="/jc-estimate-create"
                element={<CreateJcEstimateComponent />}
              />
              <Route
                exact
                path="/jc-estimate-view"
                element={<JcEstimateViewPage />}
              />
              <Route
                exact
                path="/job-card-create"
                element={<CreateJobCardComponent />}
              />
              <Route
                exact
                path="/job-card-view"
                element={<ViewJobCardComponent />}
              />
              <Route
                exact
                path="/job-card-approve"
                element={<ApproveJobCardComponent />}
              />
              <Route
                exact
                path="/job-card-close"
                element={<CloseJobCardComponent />}
              />
              {/*Shared*/}
              <Route path="/ticket" element={<TicketComponent />} />
              <Route
                exact
                path="/accessory-category"
                element={<AccessoryCategoryComponent />}
              />
              <Route
                exact
                path="/issue-type"
                element={<IssueTypeComponent />}
              />

              {/*My Inbox*/}
              <Route path="/my-inbox" element={<MyInboxComponent />} />

              {/*Inventory*/}
              <Route path="/inventory" element={<InventoryComponent />} />
              <Route
                path="/inventory/requisitions"
                element={<RequisitionIndex />}
              />
              <Route
                path="/inventory/issue-stock"
                element={<RequisitionIndex issueMode={true} />}
              />
              <Route
                path="/inventory/requisition-create"
                element={<CreateRequisitionComponent />}
              />
              <Route
                path="/inventory/stock-transfer"
                element={<StockTransferComponent />}
              />

              {/*Procurement*/}
              <Route
                exact
                path="/procurement/quotations"
                element={<ProcurementIndex />}
              />
              <Route
                exact
                path="/procurement/quotation-create"
                element={<CreateQuotationComponent />}
              />
              <Route
                exact
                path="/procurement/quotation-view"
                element={<QuotationViewPage />}
              />
              <Route
                exact
                path="/procurement/purchase-orders"
                element={<PurchaseOrderIndex />}
              />
              <Route
                exact
                path="/procurement/po-create"
                element={<CreatePoComponent />}
              />
              <Route
                exact
                path="/procurement/po-view"
                element={<PoViewPage />}
              />
              <Route exact path="/procurement/grn" element={<GrnRegister />} />
              <Route exact path="/procurement/vendor-compliance" element={<VendorCompliance />} />
              <Route exact path="/inventory/reorder" element={<InventoryReorder />} />
              <Route exact path="/procurement/budgets" element={<ProcurementBudget />} />
              <Route exact path="/procurement/rate-contracts" element={<RateContracts />} />
              <Route exact path="/procurement/vendor-scorecard" element={<VendorScorecard />} />
              <Route exact path="/procurement/contracts" element={<CompanyContracts />} />
              <Route exact path="/fitted-equipment" element={<FittedEquipment />} />
              <Route exact path="/procurement/spend-analytics" element={<SpendAnalytics />} />
              <Route exact path="/inventory/disposal" element={<Disposal />} />
              <Route exact path="/procurement/gst-input-credit" element={<GstInputCredit />} />
              <Route exact path="/vehicle-loans" element={<VehicleLoans />} />
              <Route
                exact
                path="/procurement/grn-entry"
                element={<GrnEntryComponent />}
              />
              <Route
                exact
                path="/procurement/invoice-verify"
                element={<VendorInvoiceComponent />}
              />
              <Route exact path="/procurement/rfq" element={<RfqIndex />} />
              <Route
                exact
                path="/procurement/rfq-create"
                element={<CreateRfqComponent />}
              />
              <Route
                exact
                path="/procurement/rfq-comparison"
                element={<RfqComparisonView />}
              />

              {/*PMS*/}
              <Route
                exact
                path="/pms/templates"
                element={<PmsTemplateIndex />}
              />
              <Route
                exact
                path="/pms/template-create"
                element={<CreatePmsTemplateComponent />}
              />
              <Route
                exact
                path="/pms/vehicle"
                element={<VehiclePmsDashboard />}
              />
              <Route
                exact
                path="/pms/fleet-dashboard"
                element={<PmsFleetDashboard />}
              />

              {/*Fleet Item Master*/}
              <Route
                path="/fleet-item-master"
                element={<FleetItemMasterComponent />}
              />

              {/*Payout Engine (Scheme Configurator)*/}
              <Route path="/payout-engine" element={<PayoutEngine />} />
              <Route path="/payout-engine/generate" element={<PayoutEngineGenerate />} />
              <Route
                path="/payout-engine/driver/:headerId"
                element={<PayoutEngineDriverPage />}
              />
              <Route
                path="/payout-engine-view"
                element={<PayoutEngine readOnly />}
              />
              <Route
                path="/payout-engine-view/driver/:headerId"
                element={<PayoutEngineDriverPage readOnly />}
              />
              {/* a payout of the payout history (migrated from legacy) in the same statement layout */}
              <Route
                path="/payout-engine/history/:statementId"
                element={<PayoutEngineDriverPage history />}
              />
              <Route
                path="/payout-engine-view/history/:statementId"
                element={<PayoutEngineDriverPage readOnly history />}
              />

              {/*Cost Benchmark*/}
              <Route
                path="/cost-benchmark"
                element={<CostBenchmarkAdminComponent />}
              />

              {/*Vehicle P&L*/}
              <Route path="/vehicle-pl" element={<VehiclePLDashboard />} />
              <Route path="/vehicle-cost" element={<VehicleCost />} />
              <Route path="/vehicle-rm-cost" element={<VehicleRmCost />} />
              <Route path="/tyres-batteries" element={<TyresBatteries />} />

              {/*Reports › Uber*/}
              <Route path="/uber-reports/live-board" element={<UberLiveBoard />} />
              <Route path="/uber-reports/driver-roster" element={<UberDriverRoster />} />
              <Route path="/uber-reports/vehicle-roster" element={<UberVehicleRoster />} />
              <Route path="/uber-reports/earnings" element={<UberEarnings />} />
              <Route path="/uber-reports/transactions" element={<UberTransactions />} />
              <Route path="/uber-reports/my-fleet" element={<UberMyFleet />} />
              <Route path="/uber-reports/qualification" element={<UberQualification />} />
              <Route path="/uber-reports/dm-scorecard" element={<UberDmScorecard />} />
              <Route path="/fleet-trends" element={<FleetTrends />} />
              <Route path="/fleet-hierarchy" element={<FleetHierarchyComponent />} />
              <Route path="/uber-reports/scorecard" element={<UberScorecard />} />
              <Route path="/uber-api-settings" element={<UberApiSettings />} />

              {/*Fleet Expenses*/}
              <Route
                path="/fleet-expenses"
                element={<FleetExpensesComponent />}
              />
              <Route
                path="/expense-limit-settings"
                element={<ExpenseLimitSettingsComponent />}
              />
              <Route
                path="/vehicle-expense-config"
                element={<VehicleExpenseConfigComponent />}
              />
              <Route
                path="/expense-reserve-pool"
                element={<ExpenseReservePoolComponent />}
              />

              {/*Workflow*/}
              <Route
                path="/workflow-builder"
                exact
                element={<WorkflowBuilderComponent />}
              />
              <Route
                path="/workflow-instances"
                exact
                element={<WorkflowInstanceComponent />}
              />
              <Route path="/my-approvals" element={<MyApprovalsComponent />} />

              {/*Change Request*/}
              <Route
                path="/change-request-scheme"
                exact
                element={<SchemeChangeRequestComponent />}
              />
              <Route
                path="/change-request-scheme-add"
                exact
                element={<SchemeChangeRequestAddComponent />}
              />
              <Route
                exact
                path="/change-request-scheme-view"
                element={<SchemeChangeRequestViewComponent />}
              />
              <Route
                exact
                path="/change-request-scheme-bulk-upload"
                element={<SchemeChangeRequestBulkUploadComponent />}
              />
              <Route
                exact
                path="/change-request-scheme-approval"
                element={<SchemeChangeRequestApprovalComponent />}
              />
              <Route
                exact
                path="/change-request-branch-operator"
                element={<OperatorBranchChangeRequestComponent />}
              />
              <Route
                exact
                path="/change-request-branch-operator-add"
                element={<OperatorBranchChangeRequestAddComponent />}
              />
              <Route
                exact
                path="/change-request-branch-operator-view"
                element={<OperatorBranchChangeRequestViewComponent />}
              />
              <Route
                exact
                path="/change-request-branch-operator-approval"
                element={<OperatorBranchChangeRequestApprovalComponent />}
              />
              <Route
                exact
                path="/change-request-branch-vehicle"
                element={<VehicleBranchChangeRequestComponent />}
              />
              <Route
                exact
                path="/change-request-branch-vehicle-add"
                element={<VehicleBranchChangeRequestAddComponent />}
              />
              <Route
                exact
                path="/change-request-branch-vehicle-view"
                element={<VehicleBranchChangeRequestViewComponent />}
              />
              <Route
                exact
                path="/change-request-branch-vehicle-approval"
                element={<VehicleBranchChangeRequestApprovalComponent />}
              />
              <Route
                exact
                path="/partner-document-change-request"
                element={<PartnerDocumentChangeRequestComponent />}
              />
              <Route
                exact
                path="/partner-document-change-request-view"
                element={<PartnerDocumentChangeRequestViewComponent />}
              />
              <Route
                exact
                path="/partner-document-change-request-approval"
                element={<PartnerDocumentChangeRequestApprovalComponent />}
              />
              <Route
                exact
                path="/partner-document-change-request-approval-v2"
                element={<PartnerDocumentChangeRequestApprovalV2Component />}
              />
              <Route
                exact
                path="/partner-document-change-request-approval-v3"
                element={<PartnerDocumentChangeRequestApprovalV3Component />}
              />
              <Route
                exact
                path="/partner-document-change-request-approval-v4"
                element={<PartnerDocumentChangeRequestApprovalV4Component />}
              />
              <Route
                exact
                path="/partner-document-change-request-approval-v5"
                element={<PartnerDocumentChangeRequestApprovalV5Component />}
              />
              <Route
                exact
                path="/partner-document-change-request-approval-showcase"
                element={
                  <PartnerDocumentChangeRequestApprovalShowcaseComponent />
                }
              />
              <Route
                exact
                path="/partner-document-change-request-add"
                element={<PartnerDocumentChangeRequestAddComponent />}
              />
              <Route
                exact
                path="/partner-document-change-request-add-v2"
                element={<PartnerDocumentChangeRequestAddV2Component />}
              />
              <Route
                exact
                path="/partner-document-change-request-add-showcase"
                element={<PartnerDocumentChangeRequestAddShowcaseComponent />}
              />
              <Route
                exact
                path="/change-request-operator"
                element={<ChangeOperatorRequestComponent />}
              />
              <Route
                exact
                path="/change-request-operator-add"
                element={<AddChangeOperatorRequestComponent />}
              />
              <Route
                exact
                path="/change-request-operator-add-showcase"
                element={<AddChangeOperatorRequestV2Component />}
              />
              <Route
                exact
                path="/change-request-operator-view"
                element={<ViewChangeOperatorRequestComponent />}
              />
              <Route
                exact
                path="/change-request-operator-approval"
                element={<ApprovalChangeOperatorRequestComponent />}
              />
              <Route
                path="/driver-park-request"
                element={<DriverParkComponent />}
              />
              {/*End Route--------------*/}

              <Route
                exact
                path="/vendor-add"
                element={<AddVendorComponent />}
              />
              <Route
                exact
                path="/vendor-champions"
                element={<VendorChampionsComponent />}
              />
              <Route
                path="/savedriverparnterinfo"
                element={<SaveDriverPartnerInfoComponent />}
              />
              <Route
                path="/saveaadhardetails"
                element={<SaveAadharCardDetailsComponent />}
              />
              <Route
                path="/savepancarddetails"
                element={<SavePanCardDetailsComponent />}
              />
              <Route
                path="/savedrivinglicensedetails"
                element={<SaveDrivingLicenseDetailsComponent />}
              />
              <Route
                path="/savedriverprofilephoto"
                element={<SaveDriverProfilePhotoComponent />}
              />
              <Route
                path="/savepolicecertificate"
                element={<SavePoliceClearanceCertificateComponent />}
              />
              <Route
                path="/savecourtrecordstatus"
                element={<SaveCourtRecordStatusComponent />}
              />
              <Route
                path="/saveemergencycontact"
                element={<SaveEmergencyContactComponent />}
              />
              <Route
                path="/saveguarantordetails"
                element={<SaveGuarantorDetailsComponent />}
              />
              <Route
                path="/saveaddressdetails"
                element={<SaveAddressDetailsComponent />}
              />
              <Route
                path="/savebankdetails"
                element={<SaveBankDetailsComponent />}
              />

              <Route
                path="/fieldexecutive"
                element={<FieldExecutivesComponent />}
              />
              <Route path="/incentive" element={<IncentivesComponent />} />

              <Route
                path="/incentive-scheme"
                element={<IncentiveSchemeComponent />}
              />
              <Route
                path="/targetmapping"
                element={<TargetMappingComponent />}
              />
              <Route
                path="/markcarforrecovery"
                element={<MarkCarforRecoveryComponent />}
              />
              <Route
                path="/carimmobilization"
                element={<CarImmobilizationComponent />}
              />
              <Route path="/waiver" element={<WaiverComponent />} />
              <Route path="/penalty" element={<PenaltyComponent />} />

              <Route
                path="/driverterminate"
                element={<DriverTerminateComponent />}
              />
              <Route
                path="/driverblacklist"
                element={<DriverBlackListComponent />}
              />
              <Route path="/driverleft" element={<DriverLeftComponent />} />
              <Route path="/driverrejoin" element={<DriverRejoinComponent />} />
              <Route
                path="/driver-change-request"
                element={<DriverChangeRequestComponent />}
              />
              <Route
                path="/vehiclerelease"
                element={<VehicleReleaseComponent />}
              />
              <Route
                path="/driver-settlement"
                element={<DriverPartnerSettlementComponent />}
              />
              <Route
                path="/drivermanagersettlement"
                element={<DriverManagerSettlementComponent />}
              />
              <Route
                exact
                path="/operator-master"
                element={<OperatorMasterComponent />}
              />
              <Route path="/warroom" element={<WarRoomComponent />} />
              <Route path="/champion" element={<Champion />} />
              <Route
                path="/operationspartnerincentive"
                element={<OperationsPartnerIncentiveComponent />}
              />
              <Route
                path="/driverpartnerpark"
                element={<DriverPartnerParkComponent />}
              />
              <Route
                path="/driverpartnerterminate"
                element={<DriverPartnerTerminateComponent />}
              />
              <Route
                path="/driverpartnerblocklist"
                element={<DriverPartnerBlocklistComponent />}
              />

              <Route
                path="/viewvehicleinventoryqc"
                element={<ViewInventoryVehicleQCComponent />}
              />
              <Route
                path="/competitor-scheme"
                element={<CompetitorSchemeComponent />}
              />

              <Route
                path="/vehiclealerts"
                element={<VehicleAlertsComponent />}
              />
              <Route path="/rate-card" element={<RateCardComponent />} />
              <Route path="/estimate" element={<EstimateComponent />} />
              <Route path="/workapproval" element={<WorkApprovalComponent />} />
              <Route
                path="/vehicleprofitloss"
                element={<VehicleProfitLossComponent />}
              />
              <Route
                path="/stamppaperinventory"
                element={<StampPaperInventoryComponent />}
              />
              <Route
                path="/stamppapersummary"
                element={<StampPaperSummaryComponent />}
              />

              <Route path="/branch-area" element={<BranchAreaComponent />} />
              <Route
                exact
                path="/lead-vehicle-allocation"
                element={<VehicleAllocationComponent />}
              />
              <Route path="/leadinfo" element={<LeadInfoComponent />} />
              <Route path="/vehicleinfo" element={<VehicleInfoComponent />} />
              <Route path="/schemeinfo" element={<SchemeInfoComponent />} />

              <Route
                path="/agreementcontract"
                element={<AgreementContractComponent />}
              />
              <Route
                exact
                path="/scheme-deposit"
                element={<SchemeDepositComponent />}
              />
              <Route
                exact
                path="/scheme-agreement"
                element={<SchemeAgreementComponent />}
              />
              <Route
                path="/agent-attendance"
                element={<AgentAttendanceLogComponent />}
              />

              <Route path="/gatepass" element={<GatePassComponent />} />
              <Route
                path="/item-category"
                element={<ItemCategoryComponent />}
              />
              <Route path="/items" element={<ItemsComponent />} />
              <Route path="/item-type" element={<ItemTypeComponent />} />

              <Route
                path="/agent-attendance"
                element={<AgentAttendanceLogComponent />}
              />
              <Route
                exact
                path="/configuration-report"
                element={<ReportConfigurationComponent />}
              />
              <Route
                path="/orgnizations"
                element={<UberOrgnizationsComponent />}
              />
              <Route
                path="/uber-dashboard"
                element={<UberSyncDashboardComponent />}
              />
              <Route path="/uber-drivers" element={<UberDriversComponent />} />
              <Route
                path="/uber-vehicles"
                element={<UberVehiclesComponent />}
              />
              <Route
                path="/uber-supplier-performance"
                element={<UberSupplierPerformanceComponent />}
              />
              <Route
                path="/uber-data-notification-report"
                element={<UberDataNotificationReportComponent />}
              />

              <Route path="/ameyotoolbar" element={<AmeyoToolbarComponent />} />

              <Route
                path="/access-permission"
                element={<AccessPermissionComponent />}
              />
              <Route path="/adjustment" element={<AdjustmentComponent />} />
              <Route
                exact
                path="/user-mapping"
                element={<ParentChildUserMappingComponent />}
              />

              <Route path="/tele-agent" element={<TeleAgentComponent />} />
              <Route
                path="/payment-gateway"
                element={<PaymentGatewayComponent />}
              />

              <Route path="/report" element={<ReportsComponent />} />
              <Route
                path="/lead-source-city-visit-report"
                element={<LeadSourceCityVisitReportComponent />}
              />
              <Route
                path="/agent-branch-report"
                element={<AgentBranchReportComponent />}
              />

              <Route path="/paylater" element={<PayLaterComponent />} />
              <Route exact path="/user-otp" element={<UserOtpComponent />} />
              <Route
                path="/requestaddschememaster"
                element={<RequestAddSchemeComponent />}
              />

              <Route
                path="/deposit-convert-operator-request"
                element={<DepositChangeOperatorRequestComponent />}
              />
              <Route
                path="/requestinfo"
                element={<ChangeRequestInfoComponent />}
              />
              <Route
                path="/changerequest-vehicleinfo"
                element={<ChangeRequestVehicleInfoComponent />}
              />
              <Route
                path="/changerequest-schemeinfo"
                element={<ChangeRequestSchemeInfoComponent />}
              />
              <Route
                path="/change-operator-pay-later"
                element={<ChangeOperatorPayLaterComponent />}
              />
            </Route>
          </Routes>
        </AuthorisedLayout>
      ) : (
        <Suspense fallback={<Loader />}>
          <Routes>
            <Route path="/" element={<LoginPage />} />
            <Route path="*" element={<LoginPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route
              path="/razorpay-payment"
              element={<RazorpayPaymentComponent />}
            />
            <Route
              path="/agreement-verification"
              element={<AgreementVerificationComponent />}
            />
            <Route
              path="/bank-account-confirm"
              element={<BankAccountConfirmationComponent />}
            />
            <Route path="/vendor-portal" element={<VendorQuotationPortal />} />
            <Route
              path="/bank-account-cancel"
              element={<BankAccountCancelComponent />}
            />
            <Route
              path="/delete-account"
              element={<DeleteAccountComponent />}
            />
          </Routes>
        </Suspense>
      )}
    </>
  );
}
export default App;

function AuthorizedRouteWrapper() {
  return (
    <>
      <Suspense fallback={<Loader />}>
        <Outlet />
      </Suspense>
    </>
  );
}
function RanderDashboard() {
  let dashboard = <OperationsDashboardComponent />;
  switch (LocalStorage.UserTypeId) {
    case UserType.DriverManager:
      dashboard = <DmPerformanceDashboardComponent />;
      break;
    case UserType.RepairAndMaintenanceAdmin:
      dashboard = <RMDashboardComponent />;
      break;
    default:
      break;
  }
  return dashboard;
}
